import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const BackButton: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  if (location.pathname === '/') return null;

  return (
    <Button
      variant="outlined"
      startIcon={<ArrowBackIcon />}
      onClick={() => navigate(-1)}
      sx={{ mb: 2 }}
    >
      Назад
    </Button>
  );
};
